import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as agentInfoVerificationsActions from '../../agent-info-verification/redux/actions';
import { PageLastLoaded } from '../../common/PageLastLoaded';
import { NavPageWrapper } from '../../common/Nav';
import { AgentSchedule } from './AgentSchedule/AgentSchedule';
import { default as SupervisorSchedule } from './SupervisorSchedule/SupervisorSchedule';
import moment from 'moment-timezone';
import AgentInfoVerificationConfirmationModal from '../../agent-info-verification/components/AgentInfoVerificationConfirmationModal';
import AgentTwoStepVerificationModal from '../../agent-info-verification/components/AgentTwoStepVerificationModal';
import isSupervisor from '../../agent-info-verification/util/isSupervisor';


export class Schedules extends Component {
	state = {
		date : this.props.match.params.date ? this.props.match.params.date : moment().format('YYYY-MM-DD')
	}

	componentWillReceiveProps(nextProps){
		const { match: { params }, selectedStartDate } = this.props;

		if(params.date !== nextProps.match.params.date){
			this.setState({ date: nextProps.match.params.date })
		}

		if(selectedStartDate!== nextProps.selectedStartDate){
			this.setState({ date: nextProps.selectedStartDate })
		}
	}
    
    render() {
			const {
				props: {
					User,
					position,
					agentInfoVerification: {
						showTwoStepVerificationPromptModal,
						agentInfoVerificationSubmitted,
						verificationLocationEnabled
					},
					actions: {
						agentInfoVerificationSubmitted: agentInfoVerificationSubmittedAction,
						restartAgentVerificationInfoAction,
						clearAgentInfoVerificationAction
					}
				},
				state: { date }
			} = this;

			let path = this.props.match.path;
			let { agentID, agentName, teamID, muID} = this.props.match.params;
			let isSupervisorViewOfAgentSchedule = (agentID && agentName && teamID && muID) !== undefined;
			let userID = User.userID;

			if(showTwoStepVerificationPromptModal && !agentInfoVerificationSubmitted) {
				userID = isSupervisor(User);
			}

			return (
				<NavPageWrapper currPath={path}>
					<PageLastLoaded />
					{ (agentInfoVerificationSubmitted && verificationLocationEnabled) && (
						<AgentInfoVerificationConfirmationModal 
							agentInfoVerificationSubmitted={ agentInfoVerificationSubmittedAction }
						/>
					)}

					{ (showTwoStepVerificationPromptModal && verificationLocationEnabled && !agentInfoVerificationSubmitted) && (
						<AgentTwoStepVerificationModal 
							agentID={userID}
							restartAgentVerificationInfoAction={ restartAgentVerificationInfoAction }
							clearVerificationInfo={clearAgentInfoVerificationAction}
						/>
					)}

					{ 
						User.position === position.agent || isSupervisorViewOfAgentSchedule ? 
							<AgentSchedule 
								agentID={agentID}
								agentName={agentName}
								teamID={teamID}
								muID={muID}
								date={date} />
						: 
							<SupervisorSchedule /> 
					}
				</NavPageWrapper>
			);
    }
}
/* istanbul ignore next */
function mapStateToProps({ 
	common: { user: User, position },
	schedules: { selectedStartDate, selectedEndDate },
	agentInfoVerification
}) {
	return {
		User,
		position,
		selectedStartDate,
		selectedEndDate,
		agentInfoVerification
	};
}
/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators({ ...agentInfoVerificationsActions }, dispatch)});

export default connect(mapStateToProps, mapDispatchToProps)(Schedules);



// WEBPACK FOOTER //
// ./src/features/schedules/Schedules/Schedules.js